import axios from 'axios';
import { AppSettings,Storage } from '../../configs';
import { authHeader } from '../../helpers/auth-header';
import {
  UPDATE_GR_DETAIL,
  UPDATE_GR_ITEM,
  UPDATE_GR_SERVICE_ITEM,
  UPDATE_GR_SERVICE_LINE,
  UPDATE_GR_ITEM_ACCOUNT_ASSIGNMENT,
  UPDATE_GR_SERVICE_ACCOUNT_ASSIGNMENT,
  UPDATE_GR_ITEM_MODAL,
  UPDATE_GR_SERVICELINE_MODAL,
  SELECT_ITEM_GR_SERVICE,
  START_LOADING,
  STOP_LOADING,
}
  from './actionTypes';


export function updateGR_DetailAction(data, fieldName) {
  return function (dispatch) {
    dispatch({
      type: UPDATE_GR_DETAIL,
      data: data,
      fieldName: fieldName
    });
  }
}

export function updateGR_ItemAction(data, index, fieldName, clear=false) {
  return function (dispatch) {
    dispatch({
      type: UPDATE_GR_ITEM,
      data: data,
      index: index,
      fieldName: fieldName,
      clear: clear
    });
  }
}

export function updateGR_ServiceAction(data, index, fieldName, clear=false) {
  return function (dispatch) {
    dispatch({
      type: UPDATE_GR_SERVICE_ITEM,
      data: data,
      index: index,
      fieldName: fieldName,
      clear: clear
    });
  }
}

export function updateGR_ServiceLineAction(data, index, fieldName, clear=false) {
  console.log("updateGR_ServiceLineAction")
  console.log("clear:"+clear);
  console.log(data);
  console.log(index);
  console.log(fieldName);
  return function (dispatch) {
    dispatch({
      type: UPDATE_GR_SERVICE_LINE,
      data: data,
      index: index,
      fieldName: fieldName,
      clear: clear
    });
  }
}

export function updateGR_ItemAccountAssignmentAction(data, index, fieldName, clear=false) {
  return function (dispatch) {
    dispatch({
      type: UPDATE_GR_ITEM_ACCOUNT_ASSIGNMENT,
      data: data,
      index: index,
      fieldName: fieldName,
      clear: clear
    });
  }
}

export function updateGR_ServiceAccountAssignmentAction(data, index, fieldName, clear=false) {
  return function (dispatch) {
    dispatch({
      type: UPDATE_GR_SERVICE_ACCOUNT_ASSIGNMENT,
      data: data,
      index: index,
      fieldName: fieldName,
      clear: clear
    });
  }
}

export function updateGR_ItemModalAction(data) {
  return function (dispatch) {
    dispatch({
      type: UPDATE_GR_ITEM_MODAL,
      data: data
    });
  }
}

export function updateGR_ServiceLineModalAction(data) {
  return function (dispatch) {
    dispatch({
      type: UPDATE_GR_SERVICELINE_MODAL,
      data: data
    });
  }
}

export function selectItemGR_ServiceAction(data) {
  return function (dispatch) {
    dispatch({
      type: SELECT_ITEM_GR_SERVICE,
      data: data
    });
  }
}

export function getDataReleaseOrderAction(q_po_no, q_itemNo) {
  return function (dispatch) {
    try {
      dispatch({
        type: START_LOADING
      })

      let promise = axios({
        headers: authHeader(),
        method: "post",
        url: `${AppSettings.apiUrl}/api/rrs/GetDataReleaseOrder`,
        params: {
          poNo: q_po_no,
          itemNo: q_itemNo
        }
      })

      promise.then(response => {
        dispatch({
          type: STOP_LOADING
        })
      }).catch(error => {
        dispatch({
          type: STOP_LOADING
        })
      })

      return promise

    } catch (error) {
      dispatch({
        type: STOP_LOADING
      })
    }
  }
}

